import { connect } from 'react-redux'
import PopulationCensusForm from './PopulationCensusForm.jsx'
import {
    getCollaborativeIndexationCreationFields,
    getDefaultEventPlace,
    getDefaultEventYear,
} from '../../../../../../redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from '../../../../../../redux/collaborativeIndexations/actions'

const mapStateToProps = (state) => ({
    fields: getCollaborativeIndexationCreationFields(state),
    defaultEventYear: getDefaultEventYear(state),
    defaultEventPlace: getDefaultEventPlace(state)
})

const mapDispatchToProps = (dispatch) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
})

export const PopulationCensusFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PopulationCensusForm)
